import styled from 'styled-components';
import {
  Section as commonSection,
  Wrapper as commonWrapper,
  Content as commonContent,
  Panel as commonPanel,
  PanelInner as commonPanelInner,
  Information as commonInformation,
  Text as commonText,
} from '../../assets/Common/Content.style';

import { Button as commonButton } from '../../assets/Common/Button.style';
import { Center as commonCenter } from '../../assets/Common/Center.style';

export const Section = styled.div`
  ${commonSection}
`;

export const Wrapper = styled.div`
  ${commonWrapper}
`;

export const Content = styled.div`
  ${commonContent}
`;

export const Panel = styled.div`
  ${commonPanel}
`;

export const PanelInner = styled.div`
  ${commonPanelInner}
`;

export const Box = styled.div`
  display: block;
  max-width: 100%;
  width: 100%;
  padding: 25px 30px 30px;
`;

export const Navigation = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;
  padding: 0 30px;
`;

export const Button = styled.button`
  ${commonButton}
  display: inline-flex;
  width: auto;
  min-width: 235px;
`;

export const Center = styled.div`
  ${commonCenter}
`;

export const Information = styled.div`
  ${commonInformation}
  max-width: 530px;
  text-align: center;
`;

export const Text = styled.p`
  ${commonText}
`;
